import axios from 'axios'

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:5001/queued-217c4/europe-west1/app' : 'https://europe-west1-queued-217c4.cloudfunctions.net/app'

export default axios
